import {createSlice} from "@reduxjs/toolkit";

/**
 * Запоминает состояние каталога курсов — выбранные фильтры, поисковый запрос
 * и номер страницы — одной строкой запроса вида `dir=languages&page=2&q=риски`.
 *
 * Зачем: со страницы курса пользователь возвращается в каталог по хлебным крошкам,
 * и без этого он попадал на первую страницу с нуля, потеряв отбор. Кнопка «назад»
 * в браузере состояние сохраняла, а крошка — нет; теперь ведут себя одинаково.
 *
 * Живёт в redux, а не в sessionStorage, потому что нужно только в пределах сессии
 * работы с сайтом и не должно переживать перезагрузку — после неё честнее показать
 * каталог целиком.
 */
const initialState = {
    /** Строка запроса последнего просмотра каталога, без ведущего «?». */
    searchString: '',
};

const coursesCatalogSlice = createSlice({
    name: 'coursesCatalogSlice',
    initialState,
    reducers: {
        rememberCatalogState: (state, action) => {
            state.searchString = action.payload || '';
        },
        forgetCatalogState: (state) => {
            state.searchString = '';
        },
    },
});

export const {rememberCatalogState, forgetCatalogState} = coursesCatalogSlice.actions;

/** Готовый путь возврата в каталог с восстановлением отбора. */
export const selectCatalogPath = (state) => {
    const search = state.coursesCatalog?.searchString;
    return search ? `/courses?${search}` : '/courses';
};

export default coursesCatalogSlice.reducer;
